export const CLASS_NAMES = {
  highlighter: 'text-purple-200 bg-transparent',
  container:
    'flex flex-col text-14-22 text-neutral-700 text-left w-full max-w-full',
  text: 'text-16-20-em text-neutral-900',
  tag: 'mr-3',
};

export const HIGHLIGHT_PROPS = {
  highlightClassName: CLASS_NAMES.highlighter,
  autoEscape: true,
};
